import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_H_C, LL_V_L, ModuleFE_Dialog } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import './Dialog_ReferencablesGraph.scss';
import { Graph_Referencables } from '../Graph_Referencables/Graph_Referencables.js';
const dialogKey = 'dialog__referencables-graph';
export class Dialog_ReferencablesGraph extends ComponentSync {
    static show = () => {
        const model = {
            dialogKey: dialogKey,
            closeOverlayOnClick: () => false,
            content: () => _jsx(Dialog_ReferencablesGraph, {})
        };
        ModuleFE_Dialog.show(model);
    };
    // ######################## Render ########################
    render() {
        return _jsxs(LL_V_L, { id: dialogKey, children: [this.render_Header(), this.render_Body()] });
    }
    render_Header = () => {
        return _jsxs(LL_H_C, { className: 'dialog__header', children: ["Referencables Graph", _jsx(ICONS.x.component, { onClick: () => ModuleFE_Dialog.close() })] });
    };
    render_Body = () => {
        return _jsx(Graph_Referencables, {});
    };
}
//# sourceMappingURL=Dialog_ReferencablesGraph.js.map